(function () {
  'use strict';

  const shell = document.getElementById('tlmGameShell');

function isMobile() {
  return window.innerWidth <= 900;
}

let hasTriggeredFullscreen = false;

async function tryMobileFullscreen() {
  if (!isMobile()) return;
  if (hasTriggeredFullscreen) return;

  hasTriggeredFullscreen = true;

  try {
    if (shell && shell.requestFullscreen) {
      await shell.requestFullscreen();
    }
  } catch (e) {
    console.warn('Fullscreen blocked:', e);
  }

  try {
    if (screen.orientation && screen.orientation.lock) {
      await screen.orientation.lock('landscape');
    }
  } catch (e) {
    console.warn('Orientation lock failed:', e);
  }
}

  const STANDARD = [
    'standard_awake',
    'standard_emerge',
    'standard_reveal',
    'standard_reflect',
    'standard_connect',
    'standard_embrace',
    'standard_shadow',
    'standard_light'
  ];

  const NG = [
    'ng_awake',
    'ng_emerge',
    'ng_reveal',
    'ng_reflect',
    'ng_connect',
    'ng_embrace',
    'ng_shadow',
    'ng_light'
  ];

  const frame = document.getElementById('stageFrame');
  const fallback = document.getElementById('fallback');

  let STAGE_DATA = null;
  let currentSet = 'standard';
  let index = 0;
  let activeUrl = null;

  function showFallback(message) {
    if (fallback) {
      fallback.style.display = 'flex';
      fallback.textContent = message || 'Loading failed. Refresh.';
    }
  }

  function decode(b64) {
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);

    for (let i = 0; i < bin.length; i++) {
      bytes[i] = bin.charCodeAt(i);
    }

    return new TextDecoder('utf-8').decode(bytes);
  }

  function stageList() {
    return currentSet === 'ng' ? NG : STANDARD;
  }

  function revokeOld() {
    if (activeUrl) {
      try {
        URL.revokeObjectURL(activeUrl);
      } catch (e) {}

      activeUrl = null;
    }
  }

  function loadStage(i) {
    const list = stageList();

    if (i < 0) i = 0;
    if (i >= list.length) i = list.length - 1;

    index = i;

    const key = list[index];
    const b64 = STAGE_DATA && STAGE_DATA[key];

    if (!b64) {
      showFallback('Loading failed. Missing stage: ' + key);
      return;
    }

    try {
      const stageHtml = decode(b64);
      revokeOld();

frame.style.display = 'block';
fallback.style.display = 'none';

try {
  frame.srcdoc = stageHtml;
} catch (e) {
  console.warn('srcdoc failed, falling back to blob', e);

  const blob = new Blob([stageHtml], { type: 'text/html' });
  const url = URL.createObjectURL(blob);

  activeUrl = url;
  frame.src = url;
}
    } catch (e) {
      console.error(e);
      showFallback('Loading failed. Refresh.');
    }
  }

  function nextStage() {
    if (index < stageList().length - 1) {
      loadStage(index + 1);
    }
  }

  function startNewGamePlus() {
    try {
      localStorage.setItem('NG_PLUS', 'true');
      localStorage.setItem('TLGM_NG_PLUS', 'true');
    } catch (e) {}

    currentSet = 'ng';
    loadStage(0);
  }

  function bootGame() {
    try {
      const parts = window.TLGM_STAGE_JSON_PARTS || [];

      if (!parts.length) {
        showFallback('Loading failed. Stage data not found.');
        return;
      }

      STAGE_DATA = JSON.parse(parts.join(''));
    } catch (e) {
      console.error(e);
      showFallback('Loading failed. Stage data could not be read.');
      return;
    }

    try {
      localStorage.removeItem('NG_PLUS_PENDING_BOOT');
    } catch (e) {}

    currentSet = 'standard';
    index = 0;
    loadStage(0);
  }

  window.addEventListener('message', function (ev) {
    const data = ev.data || {};

    if (!data || typeof data !== 'object') return;

    if (data.type === 'TLGM_STAGE_CLEAR') {
      nextStage();
      return;
    }

    if (data.type === 'TLGM_GAME_COMPLETE') {
      try {
        localStorage.setItem('NG_PLUS', 'true');
        localStorage.setItem('TLGM_NG_PLUS', 'true');
      } catch (e) {}

      return;
    }

    if (data.type === 'TLGM_PLAY_AGAIN') {
      startNewGamePlus();
      return;
    }
  });

  window.addEventListener('beforeunload', revokeOld);

 bootGame();

if (shell) {
  shell.addEventListener('touchstart', tryMobileFullscreen, { once: true });
}

})();